// src/utils/passwordPolicy.js
//Check password strength using regex

export function isStrongPassword(password) {
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/;
  return regex.test(password);
}

export function passwordPolicyMessage() {
  return "Password must be at least 8 characters and include uppercase, lowercase, number, and special character.";
}